// extracted by mini-css-extract-plugin
export var brand = "_1o-9";
export var compact = "_1o-6";
export var extraSmall = "_1o-7";
export var icon = "_1o-0";
export var large = "_1o-4";
export var light = "_1o-1";
export var medium = "_1o-5";
export var outline = "_1o-b";
export var primaryDark = "_1o-a";
export var primaryLight = "_1o-8";
export var primaryModern = "_1o-c";
export var success = "_1o-2";
export var successSolid = "_1o-3";